import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isU8a, u8aToU8a } from '@polkadot/util';
import { Raw } from "../native/Raw.js";
/** @internal */

function decodeU8aFixed(value, bitLength) {
  var u8a = u8aToU8a(value);
  var byteLength = bitLength / 8;

  if (!u8a.length) {
    return [new Uint8Array(byteLength), 0];
  }

  assert(isU8a(value) ? u8a.length >= byteLength : u8a.length === byteLength, function () {
    return "Expected input with ".concat(byteLength, " bytes (").concat(bitLength, " bits), found ").concat(u8a.length, " bytes");
  });
  return [u8a.subarray(0, byteLength), byteLength];
}
/**
 * @name U8aFixed
 * @description
 * A U8a that manages a a sequence of bytes up to the specified bitLength. Not meant
 * to be used directly, rather is should be subclassed with the specific lengths.
 */


export var U8aFixed = /*#__PURE__*/function (_Raw) {
  _inherits(U8aFixed, _Raw);

  var _super = _createSuper(U8aFixed);

  function U8aFixed(registry) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Uint8Array();
    var bitLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 256;

    _classCallCheck(this, U8aFixed);

    var _decodeU8aFixed = decodeU8aFixed(value, bitLength),
        _decodeU8aFixed2 = _slicedToArray(_decodeU8aFixed, 2),
        u8a = _decodeU8aFixed2[0],
        decodedLength = _decodeU8aFixed2[1];

    return _super.call(this, registry, u8a, decodedLength);
  }

  _createClass(U8aFixed, [{
    key: "toRawType",
    value:
    /**
     * @description Returns the base runtime type name for this instance
     */
    function toRawType() {
      return "[u8;".concat(this.length, "]");
    }
  }], [{
    key: "with",
    value: function _with(bitLength, typeName) {
      return /*#__PURE__*/function (_U8aFixed) {
        _inherits(_class, _U8aFixed);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, value, bitLength);
        }

        _createClass(_class, [{
          key: "toRawType",
          value: function toRawType() {
            return typeName || _get(_getPrototypeOf(_class.prototype), "toRawType", this).call(this);
          }
        }]);

        return _class;
      }(U8aFixed);
    }
  }]);

  return U8aFixed;
}(Raw);